import React from "react";
import "./Reports.less";
import moment from "moment";
import ReportsNav from "../common/ReportsNav/ReportsNav";
import HealthAndSefty from "./HealthAndSefty/HealthAndSefty";
import FacilityPerformance from "./FacilityPerformance/FacilityPerformance";
import Staffing from "./Staffing/Staffing";
import Maintenance from "./Maintenance/Maintenance";
import SiteProfile from "./SiteProfile/SiteProfile";
import Financial from "./Financial/Financial";
import SecurityAndOperations from "./SecurityAndOperations/SecurityAndOperations";
import Grid from "@material-ui/core/Grid";
import { IsSectionVisible, IsTenant } from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";
import ComingSoon from "../common/ComingSoon/ComingSoon";

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeReport: "Health & Safety"
    };
    if ((localStorage.getItem("selectedPropertyId") || "") == "") {
      localStorage.setItem("selectedPropertyId", 1);
    }
    if ((localStorage.getItem("selectedstartDate") || "") == "") {
      localStorage.setItem(
        "selectedstartDate",
        new moment()
          .startOf("month")
          .format("MM/DD/YYYY")
      );
    }
    if ((localStorage.getItem("selectedendDate") || "") == "") {
      localStorage.setItem(
        "selectedendDate",
        new moment()
          .endOf("month")
          .format("MM/DD/YYYY")
      );
    }

    if ((localStorage.getItem("DateRadioSelect") || "") == "") {
      localStorage.setItem("DateRadioSelect", "MTD");
    }
  }

  /** set/change active report value */
  changeActiveReport = reportName => {
   // localStorage.setItem("DateRadioSelect", "MTD");
    this.setState({
      activeReport: reportName
    });
  };

  render() {
    const startDateMonth = localStorage.getItem("selectedstartDate");
    const endDateMonth = localStorage.getItem("selectedendDate");

    if (localStorage.getItem("DateRadioSelect") != "CDR") {
      if (moment(startDateMonth) != moment(startDateMonth).startOf("month")) {
        localStorage.setItem(
          "selectedstartDate",
          new moment(startDateMonth).startOf("month").format("MM/DD/YYYY")
        );
      }

      if (moment(endDateMonth) != moment(endDateMonth).endOf("month")) {
        localStorage.setItem(
          "selectedendDate",
          new moment(endDateMonth).endOf("month").format("MM/DD/YYYY")
        );
      }
      localStorage.setItem(
        "sliderYear",
        moment(endDateMonth)
          .endOf("month")
          .format("YYYY")
      );
      localStorage.setItem(
        "MTDDefault",
        moment(endDateMonth)
          .endOf("month")
          .format("MM")
      );
    }
    const ReportActive = (
      <>
        {/* TO DO: Replace this string with constance */}
        {this.state.activeReport == "Health & Safety" &&
        IsSectionVisible(SECTIONS.HEALTH_AND_SAFETY) ? (
          IsTenant() ? 
          <ComingSoon />
          :
          <HealthAndSefty
            userData={this.props.userData}
            // DefaultDataCenter={this.state.datacenterList[0]?.propertyID}
          />
        ) : null}

        {this.state.activeReport == "Staffing" &&
        IsSectionVisible(SECTIONS.HEALTH_AND_SAFETY) ? (
          <Staffing userData={this.props.userData} />
        ) : null}
        {this.state.activeReport == "Maintenance" ? (
          <Maintenance userData={this.props.userData} />
        ) : null}
        {this.state.activeReport == "Security" ? (
          <SecurityAndOperations userData={this.props.userData} />
        ) : null}
        {this.state.activeReport == "Facility Performance" ? (
          <FacilityPerformance userData={this.props.userData} />
        ) : null}
        {this.state.activeReport == "Financial" ? (
          <Financial userData={this.props.userData} />
        ) : null}
        {this.state.activeReport == "Site Profile" ? (
          <SiteProfile userData={this.props.userData} />
        ) : null}
      </>
    );
    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <div className={"reports-wrapper"}>
              <div className={"reports-breadcrumb-wrapper"}>
                <span className={"reports-breadcrumb"}>
                  {"HOME | "}{this.state.activeReport}{" "}
                  {this.state.activeReport == "Site Profile" ||
                  this.state.activeReport == "Financial" ||
                  this.state.activeReport == "Facility Performance"
                    ? "MONTHLY"
                    : ""}{" "}
                  {"Report\r"}
                </span>
              </div>
              <div className={"reports-nav-wrapper"}>
                <ReportsNav
                  userData={this.props.userData}
                  onNavClick={this.changeActiveReport}
                />
              </div>
              <div className={"reports-body-wrapper"}>{ReportActive}</div>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default Reports;
